import React,{useState}  from 'react'
import {Box,Typography,Container,Button,Menu,MenuItem, CircularProgress, useMediaQuery, FormControl} from '@mui/material'
import {useTheme,styled } from '@mui/material/styles'
import MoreIcon from '@mui/icons-material/MoreVert'
import {IconButton} from "@mui/material"
import Divider from '@mui/material/Divider';
import {useNavigate} from 'react-router-dom'
import { add_assessment, add_assessments, add_template,add_templates} from "../Redux/templatesSlice";
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Header from '../Components/Header'
import CustomDialog from '../Components/CustomDialog'
import {useSelector, useDispatch} from 'react-redux';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import ItemView from '../Components/ItemView';
import axios from 'axios'
import Snackbar from '@mui/material/Snackbar'
import { CalendarMonth,ArrowDropDownCircleOutlined, CopyAll, EditNote, Groups, Remove, Timelapse, Edit, AccountCircle, VisibilityOff, Visibility } from '@mui/icons-material';
import delete_assessment from '../Redux/reducers/delete_assessment';
import delete_user_ass from '../Redux/reducers/delete_user_ass';
import ContentView from '../Components/ContentView'
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import ReactPlayer from 'react-player'
import { Camera} from "react-use-camera";
import { add_job } from '../Redux/jobSlice'
import UserInput from '../Components/UserInput'
import SelectInput from '../Components/SelectInput'
import { login } from '../Redux/authSlice'
import { FileUploader } from 'react-drag-drop-files'
import CardViewDialog from '../Components/CardViewDialog'

const Accordion = styled((props) => (
	<MuiAccordion disableGutters elevation={4} square {...props} />
))(({ theme }) => ({
	'&:not(:last-child)': {
		borderBottom: 0,
	},
	'&:before': {
		display: 'none',
	},
	borderRadius:10,
	background:"black",
	margin:10
}));

const AccordionSummary = styled((props) => (
<MuiAccordionSummary
	expandIcon={<ArrowDropDownCircleOutlined sx={{ fontSize: 30 }} />}
	{...props}
/>
))(({ theme }) => ({
	background:theme.palette.mode === 'dark'? 'black': 'white',
	flexDirection: 'row',
	marginTop:10,
	marginBottom:10,
	height:150,
	'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
		transform: 'rotate(90deg)',
	},
	'& .MuiAccordionSummary-content': {
		marginLeft: theme.spacing(1),
		marginBottom: theme.spacing(1),
	}
}));
	
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: theme.spacing(2),
	background:theme.palette.mode === 'dark'? 'black' : 'white',
}));

const ContainerBox = styled(Box, {
})(({ theme}) => ({
transition: theme.transitions.create('width', {
easing: theme.transitions.easing.sharp,
duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 10,
    backgroundColor: '#100101'
  },
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 10
  },
//   background:"#100101",
  minHeight:100,
  maxHeight:300,
  justifyContent:"center",
  alignItems:"center",
  paddingBottom:20,
  marginBottom:40
}),
);

const QuestionBox = styled(Box, {
})(({ theme}) => ({
transition: theme.transitions.create('width', {
easing: theme.transitions.easing.sharp,
duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 10,
    backgroundColor: '#100101'
  },
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 10
  },
  background:"#100101",
  minHeight:100,
  maxHeight:500,
  justifyContent:"center",
  alignItems:"center",
  paddingBottom:20,
  marginBottom:40,
  borderRadius:5
}),
)

const CustomFileInput = styled('input')(({ theme }) => ({
    display: 'none',
    '& + label': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(1),
    cursor: 'pointer',
    borderRadius: 10,
    '&:hover': {
        backgroundColor: '#192f6a',
    },
    
    },
}));

const UserProfile = ()=>{

const sex_types = ["Male","Female","Other"]
const card_types = ["Passport","National ID card","Driver card","Refuge card"]

const navigate = useNavigate()
const [anchorEl, setAnchorEl] = React.useState(null);
const [mobileAnchorEl, setMobileAnchorEl] = React.useState(null);
const [expanded, setExpanded] = React.useState(true);
const dispatch = useDispatch()
const theme = useTheme()
const user = useSelector(state => state?.auth.user);
const size_sm = useMediaQuery(theme.breakpoints.up('sm'));
const [email,setEmail] = useState(user?.email)
const [first_name,setFirst_name] = useState(user?.first_name)
const [edited,setEdited] = useState("")
const [editing,setEditing] = useState(false)
const [showEdited,setShowEdited] = useState(false)
const [submitting,setSubmitting] = useState(false)
const [last_name,setLast_name] = useState(user?.last_name)
const [picture,setPicture] = useState(user?.profile)
const [password,setPassword] = useState("")
const [sex,setSex] = useState(user?.sex)
const [position,setPosition] = useState(user?.position)
const [address,setAddress] = useState(user?.address)
const [cardNumber,setCardNumber] = useState(user?.idCard)
const [cardType,setCardType] = useState("National ID card")
const [tel,setTel] = useState(user?.tel)
const [cv,setCv] = useState(user?.cv)
const [nationality,setNationality] = useState(user?.nationality)
const [birthday,setBirthday] = useState(user?.birthday)
const [isVerified,setIsVerified] = useState(user?.isVerified)
const [organization,setOrganization] = useState(user?.organization)
const [selectedFile, setSelectedFile] = useState(user?.profile ? user?.profile : null);
const [selected, setSelected] = useState(false);
const [show, setShow] = useState(true);
const [open, setOpen] = useState(false);
const [message, setMessage] = useState("");
const [deleting, setDeleting] = useState(false);
const [verifying, setVerifying] = useState(false);
const [uploading, setUploading] = useState(false);
const [isDocUploaded, setIsDocUploaded] = useState(false);
const [isCv, setIsCv] = useState(false);
const [viewDoc, setViewDoc] = useState(false);
const [file, setFile] = useState(null);
const [userFile, setUserFile] = useState(null);
const [backFile, setBackFile] = useState(null);
const [frontFile, setFrontFile] = useState(null);
const [fileCv, setFileCv] = useState(null);


const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    setSelected(true)
    setShowEdited(true)
};

const handleClearSelection = () => {
    setSelectedFile(user?.profile ? user?.profile : "");
    setSelected(false)
}
    
const handleVerify = async ()=>{
try {
    if (userFile !== null && backFile !== null && frontFile !== null) {
        
        if (cardNumber) {
            let formData = new FormData()

            setVerifying(true)
    
            formData.append("files",frontFile)
            formData.append("files",backFile)
            formData.append("files",userFile)
            formData.append("email",user?.email)
            formData.append("password",password)
            formData.append("cardType",cardType)
            formData.append("cardNumber",cardNumber)
    
            const verifyUser = await axios.post(`${process.env.REACT_APP_SOCKET_URL}api/verify/user/verify-user`,formData,{
                headers:{
                        "Content-Type":"multipart/form-data",
                        "Authorization":`Bear ${user?.accessToken}`
                    }
            }).catch(err=>{
                setVerifying(false)
                setMessage("connection error")
                setOpen(true)
            })
    
            if (verifyUser?.status == 200 && verifyUser?.data?.success) {
                console.log(verifyUser?.data)
    
                if (verifyUser?.data?.data?.isMatch) {
                    setMessage("you been verified")
                    setOpen(true)
        
                    dispatch(login({
                        ...user,
                        isUserVerified:true,
                        idCard:cardNumber,
                        cardType:cardType
                    }))
        
                    setFrontFile(null)
                    setBackFile(null)
                    setUserFile(null)
                } else {
                    setMessage(`${verifyUser?.data?.data?.description} ${verifyUser?.data?.data?.advice}`)
                    setOpen(true)
                }

            } else {
                setMessage(verifyUser?.data?.message)
                setOpen(true)
                console.log(verifyUser?.data)
            }
            setVerifying(false)
        } else {
            setMessage("give tha card number")
            setOpen(true)
        }
    } else {
        setMessage("you must upload all the files")
        setOpen(true)
    }
} catch (error) {
    console.log(error)
}
}

const handleEdit = async ()=>{
try {
    if (password !== "") {

        setSubmitting(true)
        setEditing(true)

        if (selected) {

            let formData = new FormData()

            formData.append("file",selectedFile)
            formData.append("first_name",first_name)
            formData.append("last_name",last_name)
            formData.append("email",user?.email)
            formData.append("password",password)
            formData.append("organization",organization)
            formData.append("position",position)
            formData.append("cardType",cardType)
            formData.append("idCard",cardNumber)
            formData.append("address",address)
            formData.append("tel",tel)
            formData.append("sex",sex)
            formData.append("cv",cv)
            formData.append("birthday",birthday)
            formData.append("nationality",nationality)
            formData.append("profile",user?.url || "https://")

            const editUser = await axios.put(`${process.env.REACT_APP_SOCKET_URL}api/edit/user/edit-user`,formData,{
                    headers:{
                            "Content-Type":"multipart/form-data",
                            "Authorization":`Bear ${user?.accessToken}`
                        }
                }).catch(err=>{
                    setSubmitting(false)
                    setEditing(false)
                    setMessage("connection error")
                    setOpen(true)
                })

            if (editUser?.status == 200 && editUser?.data?.success == true) {
                
                // setVisible(false)
                setMessage("your profile data has been edited")
                setOpen(true)
    
                const newUserData = {
                    ...user,
                    last_name:editUser?.data?.user?.last_name,
                    first_name:editUser?.data?.user?.first_name,
                    organization:editUser?.data?.user?.organization,
                    position:editUser?.data?.user?.position,
                    cardType:editUser?.data?.user?.cardType,
                    card:editUser?.data?.user?.card,
                    idCard:editUser?.data?.user?.idCard,
                    address:editUser?.data?.user?.address,
                    tel:editUser?.data?.user?.tel,
                    sex:editUser?.data?.user?.sex,
                    cv:editUser?.data?.user?.cv,
                    birthday:editUser?.data?.user?.birthday,
                    nationality:editUser?.data?.user?.nationality,
                    profile:editUser?.data?.user?.profile
                }
    
                setPassword("")
                localStorage.removeItem("iTestUser")
                localStorage.setItem("iTestUser",JSON.stringify(newUserData))
                dispatch(login(newUserData))
                setEditing(false)
                setShowEdited(false)
                setSelected(false)
                setSubmitting(false)
    
            } else {
                setMessage(editUser?.data.message)
                setOpen(true)
                setSubmitting(false)
            }
            
        }
        else{

        const send_data = {
            first_name:first_name,
            last_name:last_name,
            email:user?.email,
            password:password,
            organization:organization,
            position:position,
            cardType:cardType,
            idCard:cardNumber,
            address:address,
            tel:tel,
            sex:sex,
            cv:cv,
            birthday:birthday,
            nationality:nationality,
            profile:user?.profile || "https://"

        }

        const editUser = await axios.put(`${process.env.REACT_APP_SOCKET_URL}api/edit/user/edit-user`,send_data,{
                headers:{
                        "Content-Type":"application/json",
                        "Authorization":`Bear ${user?.accessToken}`
                    }
            }).catch(err=>{
                console.log(err)
            })

        if (editUser?.status == 200 && editUser?.data?.success == true) {
            // setVisible(false)
            setMessage("your profile data has been edited")
            setOpen(true)

            const newUserData = {
                ...user,
                last_name:editUser?.data?.user?.last_name,
                first_name:editUser?.data?.user?.first_name,
                organization:editUser?.data?.user?.organization,
                position:editUser?.data?.user?.position,
                cardType:editUser?.data?.user?.cardType,
                card:editUser?.data?.user?.card,
                idCard:editUser?.data?.user?.idCard,
                address:editUser?.data?.user?.address,
                tel:editUser?.data?.user?.tel,
                sex:editUser?.data?.user?.sex,
                cv:editUser?.data?.user?.cv,
                birthday:editUser?.data?.user?.birthday,
                nationality:editUser?.data?.user?.nationality,
                profile:editUser?.data?.user?.profile
            }
            setPassword("")
            localStorage.removeItem("iTestUser")
            localStorage.setItem("iTestUser",JSON.stringify(newUserData))
            dispatch(login(newUserData))
            setEditing(false)
            setShowEdited(false)
            setSelected(false)
            setSubmitting(false)

        } else {
            setMessage(editUser?.data.message)
            setOpen(true)
            setEditing(false)
            setShowEdited(false)
            setSelected(false)
            setSubmitting(false)
        }
    }

} else {
    setMessage("Please,write down your password")
    setOpen(true)
}

} catch (error) {
    console.log(error)
    setMessage("error while sending")
    setOpen(true)
    setEditing(false)
    setSubmitting(false)
}
}

async function handleUploadFile(data,isCard){
	try {

		setUploading(true)

		let formData = new FormData()

		formData.append("file",data)
        formData.append("isCard",isCard)
        formData.append("email",user?.email)

		const upload = await axios.put(`${process.env.REACT_APP_SOCKET_URL}api/upload-card/upload/user/data/`,formData,{
			headers:{
				"Content-Type":"multipart/form-data",
				"Authorization":`Bear ${user?.accessToken}`
			}
		}).catch(err=>{
			setMessage("Error while uploading")
			setOpen(true)
			setUploading(false)
			console.log(err)
		})

		if (upload?.status == 200 && upload?.data?.success) {
			if (isCard) {
                const newUserData = {
                    ...user,
                    card:upload?.data?.url
                }
                setFile(null)
                localStorage.removeItem("iTestUser")
                localStorage.setItem("iTestUser",JSON.stringify(newUserData))
                dispatch(login(newUserData))

                console.log(upload?.data)
			} else {
				const newUserData = {
                    ...user,
                    cv:upload?.data?.url
                }
                setFileCv(null)
                localStorage.removeItem("iTestUser")
                localStorage.setItem("iTestUser",JSON.stringify(newUserData))
                dispatch(login(newUserData))

                console.log(upload?.data)
			}
            setPassword("")
            setEditing(false)
            setShowEdited(false)
            setSelected(false)
			setMessage("file uploaded on the server")
			setOpen(true)
			setUploading(false)
			// setUploaded(true)
		} else {
			setMessage(upload?.data?.message)
			setOpen(true)
			setUploading(false)
		}
		
	} catch (error) {
		console.log(error)
		setUploading(false)
	}
}

const handleMobileMenuClose = () => {
    setMobileAnchorEl(null);
};

const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
};

const handleMenuOpen = (event) => {
setAnchorEl(event.currentTarget);
};

const handleChange = () => (event, newExpanded) => {
	setExpanded(newExpanded ? true : false);
};

const handleSnackbarClose = ()=>{
	setOpen(false)
}

const DescriptionText = ({text,limit})=>{
	const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
	return <Typography color="white" ml={1} fontSize={13}> {displayText} </Typography>
  }

	return(
		<Box width="100%">
			<Header title="Create Assessment">
				<Breadcrumbs aria-label="breadcrumb">
					<Link  sx={{fontSize:12,color:"gray"}} underline="hover" href="/dashboard">
						Dashboard
					</Link>
					<Typography  sx={{fontSize:12,color:"gray"}}>Profile </Typography>
			</Breadcrumbs>			
			</Header>
            <Snackbar 
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }} 
                message={message} 
                onClose={handleSnackbarClose} 
                open={open} 
                autoHideDuration={5000}
            />
            <Box sx={{borderRadius:5,padding:1,width:"100%"}}>
                <Typography sx={{fontFamily:"dinofans",marginBottom:1,ml:2}}>
                    Personal detail
                </Typography>
                <Box display="flex" width="100%" flexWrap="wrap" justifyContent="space-evenly" m={2} sx={{backgroundColor:"black"}}>
                    <Box width="100%" sx={{height:80,justifyContent:"center",alignItems:"center",textAlign:"center"}}>
                        <FormControl variant="standard">
                            <CustomFileInput id="file-input" type="file" onChange={handleFileChange} />
                            <label htmlFor="file-input">
                                {
                                selected  ? 
                                    <img
                                        src={selected ? URL.createObjectURL(selectedFile) : {uri:user?.profile}}
                                        alt="profile"
                                        style={{ cursor: 'pointer',width:80,height:80,borderRadius:10 }} 
                                    />
                                : (user?.profile === "https://" && !selected)  ?
                                    <IconButton sx={{background:'#fff',borderRadius:3}}  size="large" color="inherit" >
                                        <img resizemode="cover" src={require("../assets/avatar.jpg")} width={50} height={50} style={{borderRadius:20,position:"relative"}}/>
                                    </IconButton>
                                :  <IconButton sx={{background:'#fff',borderRadius:3}}  size="large" color="inherit" >
                                        <img resizemode="cover" src={user?.profile} width={50} height={45} style={{borderRadius:20,position:"relative"}}/>
                                    </IconButton>
                                }
                            </label>
                        </FormControl>
                    </Box>
                    <Box justifyContent="flex-start" alignItems="center" sx={{width:{xs:300,md:"40%"}}}>
                        <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                            <ItemView title="First Name" content={user?.first_name}/>
                            <IconButton onClick={(e)=>{
                                setEdited("first_name")
                                setShowEdited((prev)=>!prev)
                            }}>
                                <Edit  fontSize='small'/>
                            </IconButton>
                        </Box>
                        {
                            (showEdited && edited === "first_name") && (
                                <Box m={1}>
                                <UserInput
                                        label={`First Name *`}
                                        input={first_name}
                                        setInput={setFirst_name}
                                        isPass={false}
                                    >
                                        <AccountCircle/>
                                    </UserInput>
                                </Box>
                            )
                        }
                    </Box>
                    <Box justifyContent="flex-start" alignItems="center" sx={{width:{xs:300,md:"40%"}}}>
                        <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                            <ItemView title="Last Name" content={user?.last_name}/>
                            <IconButton onClick={(e)=>{
                                setEdited("last_name")
                                setShowEdited((prev)=>!prev)
                            }}>
                                <Edit fontSize='small'/>
                            </IconButton>
                        </Box>
                        {
                            (showEdited && edited === "last_name") && (
                                <Box m={1}>
                                    <UserInput
                                        label={`Last Name*`}
                                        input={last_name}
                                        setInput={setLast_name}
                                        isPass={false}
                                    >
                                        <AccountCircle/>
                                    </UserInput>
                                </Box>
                            )
                        }
                    </Box>
                    <Box justifyContent="flex-start" alignItems="center" sx={{width:{xs:300,md:"40%"}}}>
                        <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                            <ItemView title="Email" content={user?.email}/>
                            <IconButton onClick={(e)=>{
                                navigator.clipboard.writeText(user?.email)
                                setMessage("email copied")
                                setOpen(true)
                            }}>
                                <CopyAll fontSize='small'/>
                            </IconButton>
                        </Box>                
                    </Box>
                    <Box justifyContent="flex-start" alignItems="center" sx={{width:{xs:300,md:"40%"}}}>
                        <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                            <ItemView title="Nationality" content={user?.nationality ? user?.nationality : "unknown"}/>
                            <IconButton onClick={(e)=>{
                                setEdited("nationality")
                                setShowEdited((prev)=>!prev)
                            }}>
                                <Edit fontSize='small'/>
                            </IconButton>
                        </Box>
                        {
                            (showEdited && edited === "nationality") && (
                                <Box m={1}>
                                    <UserInput
                                        label={`Nationality*`}
                                        input={nationality}
                                        setInput={setNationality}
                                        isPass={false}
                                    >
                                        <AccountCircle/>
                                    </UserInput>
                                </Box>
                            )
                        }
                    </Box>
                    <Box justifyContent="flex-start" alignItems="center" sx={{width:{xs:300,md:"40%"}}}>
                        <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                            <ItemView title="Birthday" content={user?.birthday ? user?.birthday : "unknown"}/>
                            <IconButton onClick={(e)=>{
                                setEdited("birthday")
                                setShowEdited((prev)=>!prev)
                            }}>
                                <Edit fontSize='small'/>
                            </IconButton>
                        </Box>
                        {
                            (showEdited && edited === "birthday") && (
                                <Box m={1}>
                                    <UserInput
                                        label={`Birthday*`}
                                        input={birthday}
                                        isDate={true}
                                        setInput={setBirthday}
                                        isPass={false}
                                    >
                                        <AccountCircle/>
                                    </UserInput>
                                </Box>
                            )
                        }
                    </Box>
                    <Box justifyContent="flex-start" alignItems="center" sx={{width:{xs:300,md:"40%"}}}>
                        <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                            <ItemView title="Sex" content={user?.sex ? user?.sex : "unknown"}/>
                            <IconButton onClick={(e)=>{
                                setEdited("sex")
                                setShowEdited((prev)=>!prev)
                            }}>
                                <Edit fontSize='small'/>
                            </IconButton>
                        </Box>
                        {
                            (showEdited && edited === "sex") && (
                                <Box m={1}>
                                <SelectInput
                                    data={sex_types}
                                    setInput={setSex}
                                    input={sex}
                                    width={250}
                                    label="Sex "
                                />
                                </Box>
                            )
                        }
                    </Box>
                    <Box justifyContent="flex-start" alignItems="center" sx={{width:{xs:300,md:"85%"}}}>
                        <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                            <ItemView title="Tel" content={user?.tel ? user?.tel : "unknown"}/>
                            <IconButton onClick={(e)=>{
                                setEdited("tel")
                                setShowEdited((prev)=>!prev)
                            }}>
                                <Edit fontSize='small'/>
                            </IconButton>
                        </Box>
                        {
                            (showEdited && edited === "tel") && (
                                <Box m={1}>
                                    <UserInput
                                        label={`Tel*`}
                                        input={tel}
                                        setInput={setTel}
                                        isPass={false}
                                    >
                                        <AccountCircle/>
                                    </UserInput>
                                </Box>
                            )
                        }
                    </Box>
                </Box>
                <Typography sx={{fontFamily:"dinofans",marginBottom:1,ml:2}}>
                    Professional detail
                </Typography>
                <Box display="flex" flexWrap="wrap" justifyContent="space-evenly" m={2} sx={{backgroundColor:"black"}}>
                    <Box justifyContent="flex-start" alignItems="center" sx={{width:{xs:300,md:"40%"}}}>
                        <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                            <ItemView title="Organization" content={user?.organization ? user?.organization : "unknown"}/>
                            <IconButton onClick={(e)=>{
                                setEdited("organization")
                                setShowEdited((prev)=>!prev)
                            }}>
                                <Edit fontSize='small'/>
                            </IconButton>
                        </Box>
                        {
                            (showEdited && edited === "organization") && (
                            <Box m={1}>
                                <UserInput
                                        label={`Organization *`}
                                        input={organization}
                                        setInput={setOrganization}
                                        isPass={false}
                                    >
                                        <AccountCircle />
                                    </UserInput>
                            </Box>
                            )
                        }         
                    </Box>
                    <Box justifyContent="flex-start" alignItems="center" sx={{width:{xs:300,md:"40%"}}}>
                        <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                            <ItemView title="Position" content={user?.position ? user?.position : "unknown"}/>
                            <IconButton onClick={(e)=>{
                                setEdited("position")
                                setShowEdited((prev)=>!prev)
                            }}>
                                <Edit fontSize='small'/>
                            </IconButton>
                        </Box>
                        {
                            (showEdited && edited === "position") && (
                            <Box m={1}>
                                <UserInput
                                    label={`Position *`}
                                    input={position}
                                    setInput={setPosition}
                                    isPass={false}
                                >
                                    <AccountCircle />
                                </UserInput>
                            </Box>
                            )
                        }         
                    </Box>
                    <Box justifyContent="flex-start" alignItems="center" sx={{width:{xs:300,md:"40%"}}}>
                        <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                            <ItemView title="Address" content={user?.address ? user?.address : "unknown"}/>
                            <IconButton onClick={(e)=>{
                                setEdited("address")
                                setShowEdited((prev)=>!prev)
                            }}>
                                <Edit fontSize='small'/>
                            </IconButton>
                        </Box>
                        {
                            (showEdited && edited === "address") && (
                            <Box m={1}>
                                <UserInput
                                    label={`Address *`}
                                    input={address}
                                    setInput={setAddress}
                                    isPass={false}
                                >
                                    <AccountCircle />
                                </UserInput>
                            </Box>
                            )
                        }         
                    </Box>
                    <Box justifyContent="flex-start" alignItems="center" sx={{width:{xs:300,md:"40%"}}}>
                        <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                            <ItemView title="Card type" content={user?.cardType ? user?.cardType : "unknown"}/>
                            <IconButton onClick={(e)=>{
                                setEdited("cardType")
                                setShowEdited((prev)=>!prev)
                            }}>
                                <Edit fontSize='small'/>
                            </IconButton>
                        </Box>
                        {
                            (showEdited && edited === "cardType") && (
                            <Box m={1}>
                                <SelectInput
                                    data={card_types}
                                    setInput={setCardType}
                                    input={cardType}
                                    width={250}
                                    label="Card Type "
                                />
                            </Box>
                            )
                        }         
                    </Box>
                    <Box justifyContent="flex-start" alignItems="center" sx={{width:{xs:300,md:"85%"}}}>
                        <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                            <ItemView title="Card Number" content={user?.idCard ? user?.idCard : "unknown"}/>
                            <IconButton onClick={(e)=>{
                                setEdited("cardNumber")
                                setShowEdited((prev)=>!prev)
                            }}>
                                <Edit fontSize='small'/>
                            </IconButton>
                        </Box>
                        {
                            (showEdited && edited === "cardNumber") && (
                            <Box m={1}>
                                <UserInput
                                    label={`Card Number *`}
                                    input={cardNumber}
                                    setInput={setCardNumber}
                                    isPass={false}
                                >
                                    <AccountCircle />
                                </UserInput>
                            </Box>
                            )
                        }         
                    </Box>
                </Box>
                <Box  m={2} sx={{borderRadius:5,padding:2,width:{xs:450,md:"100%",paddingLeft:1}}}>
                    <Typography sx={{fontFamily:"dinofans",marginBottom:1,ml:2}}>
                        User Documents
                    </Typography>
                    <Box display="flex" flexWrap="wrap" justifyContent="space-between" pb={2} sx={{backgroundColor:"black"}}>
                        <Box justifyContent="flex-start" alignItems="center" width="60%">
                            <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                                <Box sx={{margin:1,padding:2,color:"gray",textAlign:"left",marginBottom:0}}>
                                    <Typography sx={{fontFamily:"dinofans",fontSize:13}}>
                                        Card
                                    </Typography>
                                    {
                                        user?.card !== "" ?
                                            <Button  onClick={(e)=>{
                                                e?.preventDefault()
                                                setIsCv(false)
                                                setViewDoc(true)
                                            }}  sx={{background:"#fff",color:"#000",fontFamily:"dinofans",fontSize:10,mr:1}} variant="contained">
                                                View
                                            </Button>
                                        :
                                            <Typography color="white" ml={1} fontSize={14} >
                                                Not found
                                            </Typography>
                                    }
                                </Box>
                                <IconButton onClick={(e)=>{
                                    setEdited("card")
                                    setShowEdited((prev)=>!prev)
                                }}>
                                    <Edit fontSize='small'/>
                                </IconButton>
                            </Box>
                            {
                                (showEdited && edited === "card") && (
                                <Box >
                                    <Typography sx={{fontSize:12,color:"#fff",mb:2,ml:2}}>upload card</Typography>
                                    <Box pl={2} mt={2} justifyContent="center" alignItems="center" width="40%">
                                        <FileUploader  onDrop={(file)=>{setFile(file)}} maxSize={2} multiple={false} handleChange={(file)=>{
                                            setFile(file)
                                        }} name="files" types={["PNG","JPG","JPEG"]} />
                                    </Box>
                                    {
                                        file !== null && (
                                            <Box ml={2} mt={1} justifyContent="flex-start" alignItems="center" display="flex" flexDirection="row">
                                                <Button disabled={uploading || isDocUploaded} onClick={(e)=>{
                                                    e?.preventDefault()
                                                    handleUploadFile(file,true)
                                                }}  sx={{background:"#fff",color:"#000",fontFamily:"dinofans",fontSize:10,mr:1}} variant="contained">
                                                    Upload
                                                </Button>
                                            </Box>
                                        )
                                    }
                                </Box>
                                )
                            }         
                        </Box>
                        <Box  justifyContent="flex-start" alignItems="center" width="60%">
                            <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                                <Box sx={{margin:1,padding:2,color:"gray",textAlign:"left",marginBottom:0}}>
                                    <Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:13}}>
                                        CV
                                    </Typography>
                                    {
                                        user?.cv !== "" ?
                                            <Button  onClick={(e)=>{
                                                e?.preventDefault()
                                                setIsCv(true)
                                                setViewDoc(true)
                                            }}  sx={{background:"#fff",color:"#000",fontFamily:"dinofans",fontSize:10,mr:1}} variant="contained">
                                                View
                                            </Button>
                                        :
                                            <Typography color="white" ml={1} fontSize={14} >
                                                Not found
                                            </Typography>
                                    }
                                </Box>
                                <IconButton onClick={(e)=>{
                                    setEdited("cv")
                                    setShowEdited((prev)=>!prev)
                                }}>
                                    <Edit fontSize='small'/>
                                </IconButton>
                            </Box>
                            {
                                (showEdited && edited === "cv") && (
                                <Box >
                                    <Typography sx={{fontSize:12,color:"#fff",mb:2,ml:2}}>upload cv</Typography>
                                    <Box pl={2} mt={2} justifyContent="center" alignItems="center" width="40%">
                                        <FileUploader  onDrop={(file)=>{setFileCv(file)}} maxSize={5} multiple={false} handleChange={(file)=>{
                                            setFileCv(file)
                                        }} name="files" types={["PDF"]} />
                                    </Box>
                                    {
                                        fileCv !== null && (
                                            <Box ml={2} mt={1} justifyContent="flex-start" alignItems="center" display="flex" flexDirection="row">
                                                <Button disabled={uploading} onClick={(e)=>{
                                                    e?.preventDefault()
                                                    handleUploadFile(fileCv,false)
                                                }}  sx={{background:"#fff",color:"#000",fontFamily:"dinofans",fontSize:10,mr:1}} variant="contained">
                                                    Upload
                                                </Button>
                                            </Box>
                                        )
                                    }
                                </Box>
                                )
                            }         
                        </Box>
                    </Box>
                </Box>
                {showEdited && (
                    <Box m={3}>
                        <UserInput
                                label={`Password *`}
                                input={password}
                                setInput={setPassword}
                                isPass={show}
                            >
                                <IconButton onClick={()=>{
                                        setShow(prev=>!prev)
                                }}>
                                        {show ? <VisibilityOff fontSize='15'/> : <Visibility fontSize='15'/> }
                                </IconButton>
                            </UserInput>
                    </Box>
                    )
                } 
                {/* {
                    !user?.isUserVerified && (
                        <Box  m={2} sx={{borderRadius:5,padding:2,width:{xs:450,md:"100%",paddingLeft:1}}}>
                            <Typography sx={{fontFamily:"dinofans",marginBottom:1,ml:2,color:"#ff0"}}>
                                Verify user
                            </Typography>
                            <Box display="flex" flexWrap="wrap" justifyContent="space-between" pb={2} sx={{backgroundColor:"black",width:"100%"}}>
                                <Box justifyContent="flex-start" alignItems="center" sx={{width:{xs:300,md:"45%"}}}>
                                    <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                                        <Box sx={{padding:2,color:"gray",textAlign:"left",marginBottom:0}}>
                                            <Typography sx={{fontFamily:"dinofans",fontSize:13}}>
                                                Card type
                                            </Typography>
                                        </Box>
                                    </Box>
                                        <Box >
                                            <SelectInput
                                                data={card_types}
                                                setInput={setCardType}
                                                input={cardType}
                                                width={250}
                                                label="Card Type "
                                            />
                                        </Box>         
                                </Box>
                                <Box justifyContent="flex-start" alignItems="center" sx={{width:{xs:300,md:"45%"}}}>
                                    <Box sx={{padding:2,color:"gray",textAlign:"left",marginBottom:0}}>
                                        <Typography sx={{fontFamily:"dinofans",fontSize:13}}>
                                            Card number
                                        </Typography>
                                    </Box>
                                        <Box >
                                            <UserInput
                                                label={`Card Number *`}
                                                input={cardNumber}
                                                setInput={setCardNumber}
                                                isPass={false}
                                            >
                                                <AccountCircle />
                                            </UserInput>
                                        </Box>         
                                </Box>
                                <Box justifyContent="flex-start" alignItems="center" width="60%">
                                    <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                                        <Box sx={{padding:2,color:"gray",textAlign:"left",marginBottom:0}}>
                                            <Typography sx={{fontFamily:"dinofans",fontSize:13}}>
                                                Front Card 
                                            </Typography>
                                        </Box>
                                    </Box>
                                        <Box pl={2} justifyContent="center" alignItems="center" width="40%">
                                            <FileUploader  onDrop={(file)=>{setFrontFile(file)}} maxSize={5} multiple={false} handleChange={(file)=>{
                                                setFrontFile(file)
                                            }} name="files" types={["PNG","JPG","JPEG"]} />
                                        </Box>         
                                </Box>
                                {
                                    cardType !== "Passport" && (
                                        <Box justifyContent="flex-start" alignItems="center" width="60%">
                                            <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                                                <Box sx={{padding:2,color:"gray",textAlign:"left",marginBottom:0}}>
                                                    <Typography sx={{fontFamily:"dinofans",fontSize:13}}>
                                                        Back Card 
                                                    </Typography>
                                                </Box>
                                            </Box>
                                                <Box pl={2} justifyContent="center" alignItems="center" width="40%">
                                                    <FileUploader  onDrop={(file)=>{setBackFile(file)}} maxSize={5} multiple={false} handleChange={(file)=>{
                                                        setBackFile(file)
                                                    }} name="files" types={["PNG","JPG","JPEG"]} />
                                                </Box>         
                                        </Box>
                                    )
                                }
                                <Box justifyContent="flex-start" alignItems="center" width="60%">
                                    <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                                        <Box sx={{padding:2,color:"gray",textAlign:"left",marginBottom:0}}>
                                            <Typography sx={{fontFamily:"dinofans",fontSize:13}}>
                                                User image
                                            </Typography>
                                        </Box>
                                    </Box>
                                        <Box pl={2} justifyContent="center" alignItems="center" width="40%">
                                            <FileUploader  onDrop={(file)=>{setUserFile(file)}} maxSize={5} multiple={false} handleChange={(file)=>{
                                                setUserFile(file)
                                            }} name="files" types={["PNG","JPG","JPEG"]} />
                                        </Box>        
                                </Box>   
                            </Box>
                            <Button onClick={handleVerify} disabled={verifying} sx={{background:"gold",color:"black",height:{xs:30,md:35},fontFamily:"dinofans",fontSize:12,ml:2}} variant="contained">
                                {
                                    verifying ? <CircularProgress size={20} sx={{color:"black"}}/> : "Verify"
                                }
                            </Button>
                        </Box>
                    )
                } */}
                <Button onClick={handleEdit} disabled={(submitting || !showEdited)  ? true : false} sx={{background:"#fff",color:"black",height:{xs:30,md:35},fontFamily:"dinofans",fontSize:12}} variant="contained">
                    {
                        submitting ? <CircularProgress size={20} sx={{color:"black"}}/> : "Edit"
                    }
                </Button>
            </Box>
            <CardViewDialog data={isCv ? user?.cv : user?.card} title={isCv ? "View CV" : "View Card"} visible={viewDoc} setVisible={setViewDoc}/>
		</Box>
	)
}

export default UserProfile